// import { defineStyleConfig } from '@chakra-ui/styled-system'
// import { Button as ChakraButtonTheme } from '@chakra-ui/theme/components'

import { ButtonAppearance } from './types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ButtonTheme: { variants: { [key in ButtonAppearance]: any } } = {
  variants: {
    primary: {
      variant: 'solid',
      bg: 'ge.blue',
      color: 'ge.text.inverse',
      _hover: {
        bg: 'ge.button.dark.hover',
        _disabled: {
          bg: 'ge.input.outline',
        },
      },
      _active: {
        bg: 'ge.background.dark',
      },
      _disabled: {
        bg: 'ge.input.outline',
      },
    },
    secondary: {
      variant: 'outline',
      borderColor: 'ge.blue',
      color: 'ge.blue',
      _hover: {
        borderColor: 'ge.button.dark.hover',
        color: 'ge.button.dark.hover',
        _disabled: {
          borderColor: 'ge.input.outline',
          color: 'ge.text.secondary',
        },
      },
      _disabled: {
        borderColor: 'ge.input.outline',
        color: 'ge.text.secondary',
      },
    },
    transparent: {
      variant: 'outline',
      borderColor: 'rgba(255, 255, 255, 0.36)',
      color: 'ge.text.inverse',
      _hover: {
        bgColor: 'transparent',
        borderColor: 'ge.white',
      },
    },
    text: {
      variant: 'outline',
      borderColor: 'transparent',
      _hover: {
        borderColor: 'ge.blue',
        color: 'ge.blue',
        bgColor: 'transparent',
        _disabled: {
          bg: 'ge.button.menu.hover',
          borderColor: 'transparent',
          color: 'ge.text.secondary',
        },
      },
      _active: {
        bg: '#E2E8F0',
      },
      _disabled: {
        bg: 'ge.button.menu.hover',
        color: 'ge.text.secondary',
      },
    },
    'text-border': {
      variant: 'outline',
      borderColor: 'ge.background.secondary',
      _hover: {
        borderColor: 'ge.blue',
        color: 'ge.blue',
        bgColor: 'transparent',
        _disabled: {
          bg: 'ge.button.menu.hover',
          borderColor: 'transparent',
          color: 'ge.text.secondary',
        },
      },
      _active: {
        bg: '#E2E8F0',
      },
      _disabled: {
        bg: 'ge.button.menu.hover',
        color: 'ge.text.secondary',
      },
    },
    navlink: {
      variant: 'ghost',
      justifyContent: 'flex-start',
    },
    unstyled: {},
  },
}
